import { createContext, useContext } from 'react';

export interface LocalNotification {
  id: string; // prefixed with 'local-'
  title: string;
  body: string;
  category: string; // e.g. 'alert', 'info'
  priority: string; // e.g. 'high', 'normal'
  is_read: boolean;
  created_at: string;
  action_url: string | null;
}

interface NotificationsDrawerContextValue {
  open: () => void;
  localNotifications: LocalNotification[];
  addLocalNotification: (notification: Omit<LocalNotification, 'id' | 'is_read' | 'created_at'>) => void;
  markLocalNotificationRead: (id: string) => void;
}

const NotificationsDrawerContext = createContext<NotificationsDrawerContextValue>({
  open: () => {},
  localNotifications: [],
  addLocalNotification: () => {},
  markLocalNotificationRead: () => {},
});

export const NotificationsDrawerProvider = NotificationsDrawerContext.Provider;

export function useNotificationsDrawer() {
  return useContext(NotificationsDrawerContext);
}
